export interface ApplicationFormStatus {
    id: string;
    name: string;
    color: string;
    ordinal: number;
    type: ApplicationFormStatusEnum;
    isDeleted: boolean;
    isDefaultStatus: boolean;
}

export enum ApplicationFormStatusEnum {
    AwaitingReview = 0,
    UnderReview = 1,
    AmendmentsRequired = 2,
    Rejected = 3,
    PaymentRequired = 4,
    ReservationPaid = 5,
    AwaitingSupportingInfo = 6,
    SupportingInfoSubmitted = 7,
}
